<!-- Bootstrap Alert for new version -->
@if (updateAvailable) {
<div class="alert alert-info alert-dismissible fade show mb-0 rounded-0" role="alert">
  <strong>Nieuwe frontend versie beschikbaar</strong>
  De update zal automatisch uitgevoerd worden over {{ countdown }}{{ countdown !== 1 ? 's' : '' }}.
  <button type="button" class="btn btn-sm btn-primary ms-2" (click)="reloadApp()">Update nu</button>
</div>
}

<router-outlet></router-outlet>